<template>
  <div class="heading">
    <!-- <h5>OMRON-氧疗体验管理</h5> -->
    <h5>OMRON-氧疗体验管理(测试版)</h5>
    <p>
      <i class="el-icon-s-custom user"></i>
      <!-- <i class="el-icon-s-custom user" @mouseover="showPasswordFn" @mouseout="closePasswordFn"></i> -->
      <span>{{user.nickname}}，上次登录时间 {{user.update_time}}</span>
      <i class="el-icon-switch-button logout" @click="logout"></i>
      <span class="items" v-show="showPassword">
        <span class="item" @click="toChange">修改密码</span>
      </span>
    </p>
  </div>
</template>

<script>
  // import * as api from '@/api'
  export default {
    data() {
      return {
        user: JSON.parse(localStorage.getItem('setUserInfo')) || {},
        showPassword: false
      }
    },

    methods: {
      logout() {
        this.$store.dispatch('user/logout')
      },
      showPasswordFn() {
        this.showPassword = true
      },
      closePasswordFn() {
        setTimeout(() => {
          this.showPassword = false
        }, 2000);
      },
      toChange() {
        this.$router.push({ path: '/author/change?id=' + this.user.id })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .heading {
    @extend %center;
    justify-content: space-between;
    background: #fff;
    height: 80px;
    padding: 0 20px;
    flex-flow: row nowrap;

    h5 {
      font-size: 24px;
      color: #444041;
    }

    p {
      padding: 0 20px 0 0;
      @extend %center;
      flex-flow: row nowrap;
      position: relative;

      .user {
        width: 48px;
        height: 48px;
        font: 38px/48px arial;
        background: $c;
        color: #fff;
        border-radius: 50%;
      }

      span {
        color: $c;
        font-size: 14px;
        letter-spacing: 3px;
        padding: 0 20px;
      }

      .logout {
        width: 24px;
        height: 24px;
        color: #fdb4b2;
        font: 24px/1 arial;
      }

      .items {
        display: block;
        width: 120px;
        padding: 0;
        border-radius: 5px;
        background: #fff;
        box-shadow: 0px 0px 2px #888888;
        position: absolute;
        top: 45px;
        left: 20px;
        .item {
          display: block;
          font-size: 14px;
          text-align: center;
          padding: 2px 5px;
          cursor: pointer;
          z-index: 99;
        }
      }
    }
  }
</style>